import { render } from "./dang-ky.vue?vue&type=template&id=7b520471&scoped=true"
import script from "./dang-ky.vue?vue&type=script&lang=js"
export * from "./dang-ky.vue?vue&type=script&lang=js"

import "./dang-ky.vue?vue&type=style&index=0&id=7b520471&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b520471"]])

export default __exports__